import {
  KeyboardAvoidingView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Image,
  Pressable,
  Modal,
} from "react-native";
import { modalStyleSheet, snackbarStyle } from "../../components/modalStyle";

import { useState } from "react";
import * as React from "react";

import Ionicons from "@expo/vector-icons/Ionicons";
import { useNavigation } from "@react-navigation/native";

import { sendMail, getUserAndCode, getUserById } from "../../api";

//RESPONSIVE
import "@expo/match-media";
import { useMediaQuery } from "react-responsive";

import CryptoES from "crypto-es";

export let userChange = "";

import { useTogglePasswordVisibility } from "../../hooks/useTogglePasswordVisibility";

import AsyncStorage from "@react-native-async-storage/async-storage";
const loadAsyncUser = async () => {
  return await AsyncStorage.getItem("@asyncID");
};

//TRADUCCION
import { translations } from "../../components/translations";
import { I18n } from "i18n-js";
const i18n = new I18n(translations);
import { ThemeContext } from "../../components/contexts";

//TEMAS
import { useTheme } from "@react-navigation/native";

const ChangePassword = (props) => {
  const { colors } = useTheme();

  const { language } = React.useContext(ThemeContext);

  i18n.locale = language;
  i18n.enableFallback = true;

  const { passwordVisibility, rightIcon, handlePasswordVisibility } =
    useTogglePasswordVisibility();

  const [modalVisible, setModalVisible] = useState(false);
  const [visibleSnack, setVisibleSnack] = useState(false);

  const onToggleSnackBar = () => {
    setVisibleSnack(true);
    setTimeout(() => {
      setVisibleSnack(false);
    }, 2000);
  };

  const [email, setEmail] = useState({
    email: "",
    code: "",
  });

  const handleChange = (name, value) => setEmail({ ...email, [name]: value });

  let buttonStyle;

  const [textfieldStyle1, setTextfieldStyle1] = useState([
    styles.registerInputBox,
    {
      backgroundColor: colors.textInputBackground,
      borderColor: colors.main,
      borderWidth: 2,
    },
  ]);
  const [textfieldStyle2, setTextfieldStyle2] = useState([
    styles.registerInputBox,
    {
      backgroundColor: colors.textInputBackground,
      borderColor: colors.main,
      display: "none",
    },
  ]);

  let buttonDisabled;
  if (email.email !== "" && email.code !== "") {
    buttonDisabled = false;
    buttonStyle = [
      styles.nextButton,
      styles.buttonShadow,
      { backgroundColor: colors.main, shadowColor: colors.shadowColor },
    ];
  } else {
    buttonStyle = [
      styles.nextButton,
      { backgroundColor: colors.buttonDisabled },
    ];
    buttonDisabled = true;
  }

  const [displayErrorPass, setdisplayErrorPass] = useState("");
  const [displayErrorMail, setdisplayErrorMail] = useState("");

  const sendEmail = () => {
    if (email.email !== "") {
      loadAsyncUser().then((res) => {
        getUserById(res).then((result) => {
          const encryptedPasswordActual = CryptoES.SHA256(
            email.email
          ).toString();
          if (result.password == encryptedPasswordActual) {
            onToggleSnackBar();
            setTextfieldStyle1([
              styles.registerInputBox,
              {
                backgroundColor: colors.textInputBackground,
                borderColor: colors.main,
                borderWidth: 2,
              },
            ]);
            setTextfieldStyle2([
              styles.registerInputBox,
              {
                backgroundColor: colors.textInputBackground,
                borderColor: colors.main,
                borderWidth: 2,
                display: "flex",
              },
            ]);
            sendMail({ email: result.email })
              .then((resul) => {
                window
                  .open(
                    resul,
                    "Mandando correo...",
                    "width= 250, height= 150, left=0, top=0, resizable=yes, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no"
                  )
                  .blur();
              })
              .then(() => {
                window.focus();
              });
          } else {
            setTextfieldStyle1([
              styles.registerInputBoxError,
              { backgroundColor: colors.errorLight, borderColor: colors.error },
            ]);
            setdisplayErrorMail(i18n.t("contraIncorrecta"));
            setModalVisible(true);
          }
        });
      });
    } else {
      setTextfieldStyle1([
        styles.registerInputBoxError,
        { backgroundColor: colors.errorLight, borderColor: colors.error },
      ]);
      setdisplayErrorMail(i18n.t("introduceContra"));
      setModalVisible(true);
    }
  };

  //NAVIGATION
  const navigation = useNavigation();
  const navigateNext = () => {
    if (email.email !== "") {
      loadAsyncUser().then((res) => {
        userChange = res;
        getUserById(res).then((result) => {
          const encryptedPasswordActual = CryptoES.SHA256(
            email.email
          ).toString();
          if (result.password == encryptedPasswordActual) {
            setTextfieldStyle1([
              styles.registerInputBox,
              {
                backgroundColor: colors.textInputBackground,
                borderColor: colors.main,
                borderWidth: 2,
              },
            ]);
            setTextfieldStyle2([
              styles.registerInputBox,
              {
                backgroundColor: colors.textInputBackground,
                borderColor: colors.main,
                borderWidth: 2,
                display: "flex",
              },
            ]);

            if (email.code.length == 4) {
              getUserAndCode(result.email).then((resultCode) => {
                if (email.code == resultCode.code) {
                  setTextfieldStyle2([
                    styles.registerInputBox,
                    {
                      backgroundColor: colors.textInputBackground,
                      borderColor: colors.main,
                      borderWidth: 2,
                    },
                  ]);
                  setdisplayErrorPass("");
                  navigation.navigate("ChangePassword2");
                } else {
                  setTextfieldStyle2([
                    styles.registerInputBoxError,
                    {
                      backgroundColor: colors.errorLight,
                      borderColor: colors.error,
                    },
                  ]);
                  setdisplayErrorPass(i18n.t("codigoIncorrecto"));
                  setModalVisible(true);
                }
              });
            } else {
              setTextfieldStyle2([
                styles.registerInputBoxError,
                {
                  backgroundColor: colors.errorLight,
                  borderColor: colors.error,
                },
              ]);
              setdisplayErrorPass(i18n.t("codigoIncorrecto"));
              setModalVisible(true);
            }
          } else {
            setTextfieldStyle1([
              styles.registerInputBoxError,
              { backgroundColor: colors.errorLight, borderColor: colors.error },
            ]);
            setdisplayErrorMail(i18n.t("contraIncorrecta"));
            setModalVisible(true);
          }
        });
      });
    } else {
      setTextfieldStyle1([
        styles.registerInputBoxError,
        { backgroundColor: colors.errorLight, borderColor: colors.error },
      ]);
      setdisplayErrorMail(i18n.t("introduceContra"));
      setModalVisible(true);
    }
  };
  const navigateLogin = () => {
    navigation.goBack();
  };

  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
    // alternatively...
    query: "(max-device-width: 1224px)",
  });

  if (isTabletOrMobileDevice) {
    return (
      <View style={styles.container}>
        <View style={{ marginBottom: 0 }}>
          <Image
            style={styles.loginImage}
            source={require("./../../assets/MSLogo.png")}
          />
        </View>

        <View>
          <Text
            style={{
              fontFamily: "Kodchasan-Regular",
              marginTop: 60,
              textAlign: "center",
              fontSize: 18,
              color: colors.textColor,
            }}
          >
            Parece que estás utilizando un móvil o una tablet.
          </Text>
          <Text
            style={{
              fontFamily: "Kodchasan-Bold",
              marginTop: 60,
              textAlign: "center",
              color: colors.textColor,
            }}
          >
            Por favor utiliza la aplicación oficial.
          </Text>
        </View>
        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            overflow: "visible",
          }}
        >
          <TouchableOpacity
            style={{ width: "100%", height: 100, margin: 25 }}
            onPress={() => {
              window.open(
                "https://play.google.com/store/apps/details?id=com.msinvs.msinvs",
                "_blank"
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/googleplay_img.png",
              }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            style={{ width: "100%", height: 100 }}
            onPress={() => {
              window.open(
                "https://apps.apple.com/es/app/msinvs/id1565847618",
                "_blank"
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/appstore_img.png",
              }}
            />
          </TouchableOpacity>
        </View>

        <View
          style={{
            flex: 1,
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    );
  }

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: colors.main,
          justifyContent: "center",
          margin: 0,
          padding: 0,
        },
      ]}
    >
      <View
        style={[
          {
            justifyContent: "flex-start",
            alignItems: "center",
            padding: 70,
            paddingBottom: 0,
            backgroundColor: colors.background,
            borderRadius: 25,
            width: 450,
            height: 750,
          },
          styles.buttonShadow,
        ]}
      >
        <Modal animationType="fade" transparent={true} visible={visibleSnack}>
          <View style={snackbarStyle.snackContainer}>
            <View style={snackbarStyle.snackBox}>
              <Text style={snackbarStyle.snackText}>
                {i18n.t("correoEnviado")}
              </Text>
            </View>
          </View>
        </Modal>

        <Modal animationType="fade" transparent={true} visible={modalVisible}>
          <View style={modalStyleSheet.modalContainer}>
            <View
              style={[
                modalStyleSheet.modalBox,
                { backgroundColor: colors.background },
              ]}
            >
              <View style={modalStyleSheet.modalBoxErrorBox}>
                <Text
                  style={[
                    modalStyleSheet.modalBoxError,
                    { color: colors.error },
                  ]}
                >
                  {displayErrorMail}
                  {displayErrorPass}
                </Text>
              </View>
              <Pressable
                style={[
                  modalStyleSheet.modalClose,
                  { backgroundColor: colors.main },
                ]}
                onPress={() => setModalVisible(!modalVisible)}
              >
                <Text
                  style={[
                    modalStyleSheet.modalCloseText,
                    { color: colors.buttonTextColor },
                  ]}
                >
                  {i18n.t("deAcuerdo")}
                </Text>
              </Pressable>
            </View>
          </View>
        </Modal>

        <View style={styles.backButtonContainer}>
          <TouchableOpacity onPress={navigateLogin} style={styles.backButton}>
            <Ionicons
              name="ios-chevron-back"
              size={34}
              color={colors.mainTransparency}
            />
          </TouchableOpacity>
        </View>

        <View style={styles.registerImageContainer}>
          <Image
            style={styles.registerImage}
            source={require("./../../assets/MSLogo.png")}
          />

          <View style={styles.registerHeaderContainer}>
            <Ionicons name="ios-key" size={34} color={colors.main} />
            <Text
              style={[styles.registerHeaderText, { color: colors.textColor }]}
            >
              {i18n.t("cambiarContra")}
            </Text>
          </View>
        </View>
        <KeyboardAvoidingView
          behavior="position"
          style={styles.registerInputContainer}
        >
          <View style={textfieldStyle1}>
            <TextInput
              placeholder={i18n.t("contraActual")}
              placeholderTextColor={colors.mainTransparency}
              value={email.email}
              onChangeText={(text) => handleChange("email", text)}
              secureTextEntry={passwordVisibility}
              style={[styles.registerInput, { color: colors.main }]}
            />
            <Pressable onPress={handlePasswordVisibility}>
              <Ionicons
                name={rightIcon}
                size={24}
                color={colors.mainTransparency}
              />
            </Pressable>
          </View>
          <View style={{ margin: 0, padding: 0 }}>
            <TouchableOpacity
              style={styles.recoveryPressable}
              onPress={sendEmail}
            >
              <Text
                style={[
                  styles.recoveryPressableText,
                  { color: colors.mainTransparency },
                ]}
              >
                {i18n.t("pulsaParaRecibir")}
              </Text>
            </TouchableOpacity>
          </View>
          <View style={textfieldStyle2}>
            <TextInput
              placeholder={i18n.t("codigo")}
              keyboardType="numeric"
              maxLength={4}
              placeholderTextColor={colors.mainTransparency}
              value={email.code}
              onChangeText={(text) => handleChange("code", text)}
              style={[
                styles.registerInput,
                { textAlign: "center", color: colors.main },
              ]}
            />
          </View>
        </KeyboardAvoidingView>
        <View style={styles.nextButtonContainer}>
          <TouchableOpacity
            disabled={buttonDisabled}
            onPress={navigateNext}
            style={buttonStyle}
          >
            <Text
              style={[styles.nextButtonText, { color: colors.buttonTextColor }]}
            >
              {i18n.t("siguiente")}
            </Text>
          </TouchableOpacity>
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ChangePassword;

const styles = StyleSheet.create({
  container: {
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 70,
    paddingTop: 66,
    paddingBottom: 0,
    minHeight: "100%",
  },

  buttonShadow: {
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 2,
  },

  //IMAGEN LOGO
  registerImageContainer: {
    margin: "auto",
    width: "100%",
    height: "auto",
    paddingVertical: 0,
    marginBottom: 10,
  },

  registerImage: {
    alignSelf: "center",
    width: 115,
    height: 115,
    marginBottom: 10,
  },

  //OPTIONS
  registerHeaderContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginBottom: 50,
  },
  registerHeaderText: {
    fontSize: 24,
    fontFamily: "Kodchasan-Bold",
    textAlign: "center",
  },
  registerHeaderSvg: {
    marginVertical: 10,
  },

  //INPUTS
  registerInputContainer: {
    width: "100%",
  },
  registerInputBox: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 25,
    borderRadius: 10,
    borderStyle: "solid",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  registerInputBoxError: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 25,
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 2,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  registerInput: {
    flex: 1,
    outlineStyle: "none",
    fontFamily: "Kodchasan-Regular",
  },

  visibilityToggle: {
    marginLeft: 10,
  },

  //NEXT BUTTON
  nextButtonContainer: {
    width: "80%",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-end",
    minHeight: 150,
  },
  nextButton: {
    width: "100%",
    paddingVertical: 10,
    borderRadius: 20,
    textAlign: "center",
    marginBottom: 25,
  },
  nextButtonText: {
    fontSize: 13,
    fontFamily: "Kodchasan-Bold",
    textAlign: "center",
  },
  copyrightText: {
    marginBottom: "15%",
    marginTop: "5%",
    fontFamily: "Kodchasan-Regular",
    textAlign: "center",
  },

  recoveryPressable: {
    marginBottom: 25,
  },
  recoveryPressableText: {
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Roboto-Medium",
  },

  //BACK BUTTON
  backButtonContainer: {
    width: "auto",
    position: "absolute",
    top: 70,
    left: 25,
  },
});
